import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useMaunAppsStore } from '../../store/maun-apps.store';
import { useAppStore } from '../../store';
// App Components (placeholders for now, will implement actual components next)
import { DashboardApp } from './apps/DashboardApp';
import { FocusModeApp } from './apps/FocusModeApp';
import { EmotionalApp } from './apps/EmotionalApp';
import { HabitsApp } from './apps/HabitsApp';
import { JournalApp } from './apps/JournalApp';
import { VisionBoardApp } from './apps/VisionBoardApp';
import { HealthApp } from './apps/HealthApp';
import { WealthApp } from './apps/WealthApp';
import { SalesApp } from './apps/SalesApp';
import { SocialApp } from './apps/SocialApp';
import { EmailApp } from './apps/EmailApp';
import { DriveApp } from './apps/DriveApp';
const AppComponents = {
    'DashboardApp': DashboardApp,
    'FocusModeApp': FocusModeApp,
    'EmotionalApp': EmotionalApp,
    'HabitsApp': HabitsApp,
    'JournalApp': JournalApp,
    'VisionBoardApp': VisionBoardApp,
    'HealthApp': HealthApp,
    'WealthApp': WealthApp,
    'SalesApp': SalesApp,
    'SocialApp': SocialApp,
    'EmailApp': EmailApp,
    'DriveApp': DriveApp,
};
export function MaunAppLauncher() {
    const { activeApp, appContext, closeApp, getAppById, incrementUsage } = useMaunAppsStore();
    const { closeModal } = useAppStore();
    useEffect(() => {
        if (activeApp) {
            incrementUsage(activeApp);
        }
    }, [activeApp, incrementUsage]);
    if (!activeApp || !appContext) {
        return null;
    }
    const app = getAppById(activeApp);
    if (!app || !app.isInstalled || !app.isEnabled) {
        return null;
    }
    const AppComponent = AppComponents[app.component];
    if (!AppComponent) {
        return (_jsxs("div", { className: "p-6 text-center", children: [_jsx("h3", { className: "text-lg font-medium text-gray-900 mb-2", children: "App Not Available" }), _jsxs("p", { className: "text-gray-600", children: ["The ", app.name, " app is not yet implemented."] })] }));
    }
    const handleClose = () => {
        closeApp();
        closeModal();
    };
    return (_jsx("div", { className: "w-full h-full", children: _jsx(AppComponent, { context: {
                ...appContext,
                onClose: handleClose
            } }) }));
}
